import {
  PayerPayeeEngagementStatus,
  PaymentsEligibility,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { IPayerEngagement } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { EngagementType } from "@wingspanhq/payments/dist/interfaces/engagement";
import { PayeeEngagementType } from "@wingspanhq/wingspan-api-sdk";

/**
 * Human label for an engagement classification. Accepts BOTH the legacy v1
 * `EngagementType` (still used by payer/payee-engagement code) and the v3
 * `PayeeEngagementType` (engagement TYPE templates on v3) — their string values
 * don't collide, so one switch serves both during the v1→v3 coexistence.
 */
export function getEngagementLabelByType(
  type: EngagementType | PayeeEngagementType | undefined,
  options?: { descriptive?: boolean }
): string {
  switch (type) {
    case EngagementType.AgencyOfRecord:
    case PayeeEngagementType.AGENT_OF_RECORD:
      return options?.descriptive ? "Agency of Record (AOR)" : "AOR";
    case EngagementType.ContractorVendor:
    case PayeeEngagementType.CONTRACTOR:
      return options?.descriptive ? "Independent contractor (IC)" : "IC";
    case EngagementType.EmployerOfRecord:
    case PayeeEngagementType.EMPLOYEE_OF_RECORD:
      return options?.descriptive ? "Employer of Record (EOR)" : "EOR";
    case PayeeEngagementType.EMPLOYEE:
      return "Employee";
    default:
      return type ?? "";
  }
}

export function getEngagementsRequirementsCompleted(
  engagement: IPayerEngagement
): boolean {
  return (engagement.requirements || []).every(
    requirement => requirement.status === RequirementStatus.Complete
  );
}

export function getAllEngagementsEligibilityRequirementsCompleted(
  engagements: IPayerEngagement[]
): boolean {
  return (
    engagements.every(engagement => {
      const hasEngagements = !!engagement.engagementId;
      return getEngagementsRequirementsCompleted(engagement);
    }) &&
    engagements
      .filter(
        engagement => engagement.status === PayerPayeeEngagementStatus.Active
      )
      .some(
        engagement =>
          engagement.paymentsEligibility === PaymentsEligibility.Eligible
      )
  );
}

export function getHasEligibleEngagements(
  engagements: IPayerEngagement[]
): boolean {
  return engagements
    .filter(
      engagement => engagement.status === PayerPayeeEngagementStatus.Active
    )
    .some(
      engagement =>
        engagement.paymentsEligibility === PaymentsEligibility.Eligible
    );
}
